import ky from 'ky';

const restBaseUrl = window.asys_ajax_url.restUrl;
export const ajaxUrl = window.asys_ajax_url.ajaxurl;

export function makeRestClient() {
    return ky.create({
        prefixUrl: restBaseUrl,
        headers: {
            'X-WP-Nonce': window.asys_ajax_url.nonce,
        },
        throwHttpErrors: false,
    });
}

export function makeAjaxClient() {
    return ky.create({
        headers: {
            'X-WP-Nonce': window.asys_ajax_url.nonce,
        },
        throwHttpErrors: false,
    });
}
